import React, { useState } from "react";
import "../styles/RequestWithdrawal.css";
import { useNavigate } from "react-router-dom";
import ChaseBankIcon from "../icons/ChaseBankIcon.js";
import VisaIcon from "../icons/VIsaIcon.js";

function RequestWithdrawal() {
  const navigate = useNavigate();
  const [ReqWithdrow, setReqWithdrow] = useState(true);

  const handleClose = () => {
    navigate("/user-management", {
      state: { active: "I" },
    });
  };

  return (
    <div className="request-withdrawal-view">
      {ReqWithdrow ? (
        <div className="request-withrow-data-in">
          <div className="request-withdrawal-page">
            <div className="request-withdrawal-top">
              <div>
                <div className="request-withdrawal-title">
                  Request Withdrawal
                </div>
                <div className="request-withdrawal-subtitle">
                  Funds will be transferred to your linked account within 1-5
                  business days.
                </div>
              </div>
              <button
                type="button"
                className="request-withdrawal-close"
                onClick={handleClose}
                aria-label="Close request withdrawal"
              >
                x
              </button>
            </div>

            <div className="request-balance-row">
              <div className="request-balance-card request-balance-card-available">
                <div className="request-balance-label">
                  Available to withdraw
                </div>
                <div className="request-balance-value">$8,450.00</div>
              </div>

              <div className="request-balance-card request-balance-card-pending">
                <div className="request-balance-label">
                  Pending (not available)
                </div>
                <div className="request-balance-value">$1,500.00</div>
              </div>
            </div>

            <div className="request-field-group">
              <label className="request-label" htmlFor="withdrawal-amount">
                Withdrawal Amount
              </label>
              <div className="request-amount-box" id="withdrawal-amount">
                <span>$</span> 0.00
              </div>

              <div className="request-percent-row">
                <button type="button">25%</button>
                <button type="button">50%</button>
                <button type="button">75%</button>
                <button type="button">Max</button>
              </div>
            </div>

            <div className="request-field-group">
              <div className="request-label">Withdraw To</div>

              <button
                type="button"
                className="request-method-card request-method-card-selected"
              >
                <div className="request-method-left">
                  <span className="request-method-icon">
                    <ChaseBankIcon />
                  </span>
                  <div>
                    <div className="request-method-title">
                      Chase Bank ****4821
                    </div>
                    <div className="request-method-note">
                      Bank Account - Default
                    </div>
                  </div>
                </div>

                <div className="request-method-right">
                  <div className="request-method-time">
                    <span className="request-method-clock" /> 1-2 business
                    days
                  </div>
                  <span className="request-method-radio" />
                </div>
              </button>

              <button type="button" className="request-method-card">
                <div className="request-method-left">
                  <span className="request-method-icon">
                    <VisaIcon />
                  </span>
                  <div>
                    <div className="request-method-title">
                      Visa Business ****9341
                    </div>
                    <div className="request-method-note">
                      Credit Card - Expires 12/28
                    </div>
                  </div>
                </div>

                <div className="request-method-right">
                  <div className="request-method-time">
                    <span className="request-method-clock" /> 3-5 business
                    days
                  </div>
                  <span className="request-method-radio" />
                </div>
              </button>
            </div>

            <div className="request-field-group">
              <label className="request-label" htmlFor="withdrawal-notes">
                Notes <span>(optional)</span>
              </label>
              <textarea
                id="withdrawal-notes"
                className="request-notes"
                placeholder="e.g. Q2 earnings withdrawal..."
              />
            </div>

            <button
              type="button"
              className="request-submit"
              onClick={() => setReqWithdrow(false)}
            >
              Enter a valid amount
            </button>
          </div>
        </div>
      ) : (
        <div className="request-withrow-data-in request-withrow-confirm-wrap">
          <div className="request-confirm-page">
            <div className="request-confirm-top">
              <div>
                <div className="request-confirm-title">Request Withdrawal</div>
                <div className="request-confirm-subtitle">
                  Funds will be transferred to your linked account within 1-5
                  business days.
                </div>
              </div>
              <button
                type="button"
                className="request-confirm-close"
                onClick={handleClose}
                aria-label="Close request withdrawal"
              >
                x
              </button>
            </div>

            <div className="request-confirm-balance-row">
              <div className="request-confirm-balance-card">
                <div className="request-confirm-balance-label">
                  Available to withdraw
                </div>
                <div className="request-confirm-balance-value">$8,450.00</div>
              </div>

              <div className="request-confirm-balance-card">
                <div className="request-confirm-balance-label">
                  Pending (not available)
                </div>
                <div className="request-confirm-balance-value">$1,500.00</div>
              </div>
            </div>

            <div className="request-confirm-field-group">
              <div className="request-confirm-label">Withdrawal Amount</div>
              <div className="request-confirm-amount-box">0.00</div>

              <div className="request-confirm-percent-row">
                <button type="button">25%</button>
                <button type="button">50%</button>
                <button type="button">75%</button>
                <button type="button">Max</button>
              </div>
            </div>

            <div className="request-confirm-field-group">
              <div className="request-confirm-label">Withdraw To</div>

              <button type="button" className="request-confirm-method-card">
                <div className="request-confirm-method-left">
                  <ChaseBankIcon />
                  <div>
                    <div className="request-confirm-method-title">
                      Chase Bank ****4821
                    </div>
                    <div className="request-confirm-method-note">
                      Bank Account - Default
                    </div>
                  </div>
                </div>

                <div className="request-confirm-method-time">
                  1-2 business days
                </div>
              </button>

              <button type="button" className="request-confirm-method-card">
                <div className="request-confirm-method-left">
                  <VisaIcon />
                  <div>
                    <div className="request-confirm-method-title">
                      Visa Business ****9341
                    </div>
                    <div className="request-confirm-method-note">
                      Credit Card - Expires 12/28
                    </div>
                  </div>
                </div>

                <div className="request-confirm-method-time">
                  3-5 business days
                </div>
              </button>
            </div>

            <div className="request-confirm-field-group">
              <div className="request-confirm-label">Notes</div>
              <textarea className="request-confirm-notes" />
            </div>

            <button type="button" className="request-confirm-submit" />
          </div>
        </div>
      )}
    </div>
  );
}

export default RequestWithdrawal;
